import { skillGroups } from '../data/skills';
import { SkillCard } from '../components/SkillCard';
import { Reveal } from '../components/Reveal';
import './Skills.css';

export function Skills() {
  return (
    <section id="skills" className="section skills">
      <Reveal className="skills-head">
        <p className="eyebrow">{'// Tech stack'}</p>
        <h2 className="section-title">
          Tools I <span className="grad">build with</span>
        </h2>
        <p className="section-lead">
          From Flutter front-ends to FastAPI backends, LLM-powered systems, and the
          hardware in between — here's what I reach for.
        </p>
      </Reveal>

      <div className="skills-grid">
        {skillGroups.map((group, i) => (
          <Reveal key={group.category} direction="up" delay={(i % 3) + 1}>
            <SkillCard group={group} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
